/** Key storage do filtro das campanhas do cliente */
export const CAMPANHAS_FILTER_STORAGE_KEY = 'clienteCampanhaFilter';

/** Key storage da visualização das campanhas do cliente */
export const CAMPANHAS_VISUALIZACAO_STORAGE_KEY = 'clienteCampanhaVisualizacao';
